import React from "react";

// U-magnet icon — exact path from Figma, fill #00B8D9
export const MagnetIcon = () => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 12.75 13.5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 3.85714V6.75C0 10.4776 2.85452 13.5 6.375 13.5C9.89548 13.5 12.75 10.4776 12.75 6.75V3.85714H9.10714V6.75C9.10714 8.3471 7.88337 9.64286 6.375 9.64286C4.86663 9.64286 3.64286 8.3471 3.64286 6.75V3.85714H0ZM0 2.89286H3.64286V0.964286C3.64286 0.430915 3.23588 0 2.73214 0H0.910714C0.406975 0 0 0.430915 0 0.964286V2.89286ZM9.10714 2.89286H12.75V0.964286C12.75 0.430915 12.343 0 11.8393 0H10.0179C9.51412 0 9.10714 0.430915 9.10714 0.964286V2.89286Z"
      fill="#00B8D9"
    />
  </svg>
);
